// Charges Module Types

export enum ChargeType {
  MAINTENANCE = 'MAINTENANCE',
  FINE = 'FINE',
  LATE_FEE = 'LATE_FEE',
  EXTRA = 'EXTRA',
  SERVICE = 'SERVICE',
  DEPOSIT = 'DEPOSIT',
  OTHER = 'OTHER',
}

export enum ChargeStatus {
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
}

export interface Charge {
  id: string;
  memberId: string;
  type: ChargeType;
  concept: string;
  amount: number;
  balance: number;
  period: string | null;
  dueDate: string;
  status: ChargeStatus;
  reference: string | null;
  notes: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
  isOverdue: boolean;
  daysOverdue: number;
  memberName?: string;
  unitId?: string;
  unitName?: string;
}

export interface ChargeSummary {
  totalPending: number;
  totalPartial: number;
  totalPaid: number;
  amountPending: number;
  amountPaid: number;
}

export interface MemberChargeSummary {
  memberId: string;
  memberName: string;
  totalOwed: number;
  pendingAmount: number;
  overdueAmount: number;
  pendingCount: number;
  overdueCount: number;
  nextDueDate: string | null;
}

export interface CreateChargeDTO {
  unitId: string;
  type: ChargeType;
  concept: string;
  amount: number;
  period?: string;
  dueDate: string;
  reference?: string;
  notes?: string;
}

export interface UpdateChargeDTO {
  concept?: string;
  amount?: number;
  dueDate?: string;
  status?: ChargeStatus;
  notes?: string;
  reference?: string;
}

export interface GenerateBatchChargesDTO {
  unitIds: string[];
  period: string;
  /** Sin monto se cobra la cuota de cada unidad: la de su sección o la general. */
  amount?: number;
  dueDate: string;
  concept?: string;
}

export interface ChargeQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  type?: ChargeType;
  status?: ChargeStatus;
  period?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
  unitId?: string;
}
